module.exports = __webpack_public_path__ + "img/il_home.578cc713.svg";